export const priceFormat = (price: number | string, fractionDigits = 2): string => {
    return price || price === 0
        ? parseFloat(price as string).toLocaleString('ru-RU', {
              minimumFractionDigits: fractionDigits,
              maximumFractionDigits: fractionDigits,
          })
        : '';
};
